import { data } from '../../svg/Add/data';
import { makeIcon } from '../makeIcon';

export const Add = makeIcon(data, 'add', 'Add');

export default Add;
